export const statusText: { [x: string]: string } = {
	notPayed: 'Не оплачена',
	confirmed: 'Подтверждена',
	cancelled: 'Отменена',
	awaitingPayment: 'Ожидает оплаты',
	unconfirmed: 'Не подтверждена',
};
